var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0",
              attrs: { cols: "12", id: "main_content_maxwidthset" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                          },
                          attrs: {
                            id: "back_clean_btn",
                            width: "auto",
                            height: "50px",
                            elevation: "0",
                          },
                          on: { click: _vm.goSetting },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("title")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                          },
                          attrs: {
                            id: "back_clean_btn",
                            width: "auto",
                            height: "50px",
                            elevation: "0",
                          },
                          on: { click: _vm.goSearchBranchStore },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("branchSearch")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [_vm._v(" " + _vm._s("支店検索") + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: {
            id: "main_content_maxwidthset",
            cols: "12",
            align: "center",
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
            _vm._l(_vm.storeList, function (areaData, index) {
              return _c(
                "v-col",
                { key: index, staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 pt-9 pb-2",
                      attrs: { cols: "12", align: "left" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            areaData.areaName +
                              "(" +
                              areaData.stores.length +
                              ")"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm._l(areaData.stores, function (item, index_nest) {
                    return _c(
                      "v-col",
                      {
                        key: index_nest,
                        staticClass: "ma-0 pa-0",
                        attrs: { cols: "12" },
                        on: {
                          click: function ($event) {
                            return _vm.goBranchAuthoritySetting(item)
                          },
                        },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-2 pt-1 pl-9 pr-9",
                            class: {
                              user_box_top: index == 0 && index_nest == 0,
                              user_box_bottom:
                                index == _vm.storeList.length - 1 &&
                                index_nest == areaData.stores.length - 1,
                            },
                            attrs: { id: "user_box", cols: "12" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass:
                                  "ma-0 pa-2 pl-0 pr-0 user_box_border",
                                attrs: { align: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "4", align: "left" },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(item.customerName) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }